function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "#0481D9",
  d: "M125.8 1H4.2A3.2 3.2 0 001 4.2v121.6a3.2 3.2 0 003.2 3.2h121.6a3.2 3.2 0 003.2-3.2V4.2a3.2 3.2 0 00-3.2-3.2z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M69.989 48.039h8.838V37.093h-8.838c-7.312 0-13.259 6.444-13.259 14.364v5.524h-8.84v10.98h8.84v26.587h11.049V67.961h11.048v-10.98H67.779v-5.627c0-1.897 1.17-3.315 2.21-3.315z"
});

function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 130 130"
  }, props), _ref, _ref2);
}

export default SvgFacebook;